<template>
    <path :style="{ fill: color }" d="M82,36.9c-2.1-2.8-2.4-4.2-2.4-4.2l-1.3-3.1l0,0c0.1-1.6-0.2-3.5-0.9-5.2c-0.7-1.6,0.5-4.2-0.6-6.5
	c-1.1-2.2-3.1-3-3.7-3.6c-1.5-1.5-1.4-3.8-3.6-5.8c-2.7-2.5-4.8-2.8-7.2-2.4C59.9,6.5,60,5,55.5,4s-8.2,3.8-10.4,3
	c-2.3-0.8-5,0.5-6,2.5c-1,1.9-2.1,4-3.6,4.4c-1.4,0.4-2.4,1.7-3.9,3.9c-1.5,2.2-0.2,4.5-0.1,5.7c0,0.6-1.7,1.6-1.7,3.6
	c0,2.3,1.2,2.5,1.6,5.5c0,0-0.4,1.3-2.7,3.9s-5.8,5.3-5.5,7.9c0.2,2.6-0.7,6,2,7.3c2.7,1.4,0,3.5,0.9,5.4c0.9,1.8,0.6,2.3,2.5,3.1
	c1.9,0.9,2.8,1.2,3.3,1.2c0.5-0.1,2.9-0.3,4.3,0.5c0.6,0.3,1,0.6,1.4,0.8c-0.5-0.9-1-1.7-1.4-2.5c-0.6-1.3-1.1-4-1.4-7.4
	c-0.4,0.5-0.8,0.9-1.5,0.9c-1.7,0-2.3-1.8-3.4-4.1c-1.1-2.3-2.3-5.1-1.6-6.7c0.8-2.3,2.5-2.4,4-1.8c0.4,0.5,0.7,0.8,1,1.2
	c0.5,0.8,0.1,1.6,0.3,2.9c0.3,1.2,1,4.2,1.1,4.2c0.1,0,0.1-5.2,0.3-8.6c0.1-1.7,0.7-2.1,1.2-5.3c0.2-1.6,0.1-3.3,0.1-4.9l0,0
	c0,0,0,0,0,0c0-0.2,0-0.4,0-0.6c0,0,0,0,0-0.1c0-0.2,0-0.3,0.1-0.5c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.1,0-0.2
	c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3
	c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.2,0.3-0.4,0.4-0.5c0.7-0.7,1.6-1,2.7-1
	c1.4,0,3.1,0.4,4.7,0.4c0.7,0,1.4,0,2.1-0.2c0.5-0.1,0.9-0.2,1.3-0.2c2.5-0.1,4.3,1.7,7.6,2.3c0.5,0.1,1.1,0.2,1.7,0.2
	c0.3,0,0.6,0,0.9,0c3-0.1,5.1-1.6,7.1-2.3c1-0.3,1.9-0.5,2.8-0.1c0.3,0.1,0.6,0.3,0.9,0.5c0.1,0.1,0.2,0.1,0.3,0.2
	c0.2,0.1,0.3,0.2,0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.2,0.2,0.3
	c0.3,0.7,0.6,1.5,0.7,2.5c0,0,0,0,0,0c0.1,1,0.2,2.2,0.2,3.5c0,4.5,0.9,4.7,0.9,8.7C73.3,45.7,72.8,49,73,49s1.6-5.2,2-6.3
	c0.1-0.4,0.4-1,0.6-1.7c1.4-0.4,3-0.2,3.7,1.9c0.6,1.7-0.5,4.4-1.6,6.7c-1.1,2.3-1.7,4.1-3.4,4.1c-0.5,0-1-0.3-1.3-0.7
	c-0.2,2.5-0.4,4.5-0.7,5.5c-0.3,1.1-0.9,2.3-1.6,3.7c0.5-0.2,0.9-0.4,1.6-0.7c1.5-0.7,3.9-0.2,4.4-0.1c0.5,0.1,1.4-0.2,3.4-0.8
	c2-0.7,1.7-1.2,2.8-2.9c1.1-1.7-1.4-4.1,1.4-5.2c2.8-1.1,2.2-4.5,2.6-7.1C87.2,42.7,84.1,39.7,82,36.9z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair3',
        mixins: [Hair],
    }
</script>

